export function localStorage<T>(key: string) {
  function get(): T | undefined {
    if (typeof window === "undefined") {
      return;
    }

    try {
      const stringifiedData = window.localStorage.getItem(key);

      if (!stringifiedData) {
        return;
      }

      return JSON.parse(stringifiedData);
    } catch (err) {
      console.error("Error using JSON Parse.");
    }
  }

  function set(data: T): void {
    if (typeof window === "undefined") {
      return;
    }

    try {
      const stringified = JSON.stringify(data);
      window.localStorage.setItem(key, stringified);
    } catch (err) {
      console.error("Error using JSON Stringify");
    }
  }

  function clear(): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.removeItem(key);
  }

  return {
    get,
    set,
    clear,
  };
}
